import { bytify, hexify, concat, equal } from "@ckb-lumos/codec/lib/bytes";

export const bytes = { bytify, hexify, concat, equal };
export { bytify, hexify, concat, equal };

export type {
  BytesLike,
  AnyCodec,
  Codec,
  PackParam,
  PackResult,
  UnpackParam,
  UnpackResult,
  BytesCodec,
  FixedBytesCodec,
} from "@ckb-lumos/codec/lib/base";

export {
  table,
  array,
  option,
  struct,
  vector,
  union,
  byteOf,
  byteArrayOf,
  byteVecOf,
} from "@ckb-lumos/codec/lib/molecule";

export type {
  ObjectLayoutCodec,
  ArrayLayoutCodec,
  OptionLayoutCodec,
  UnionLayoutCodec,
} from "@ckb-lumos/codec/lib/molecule";

export {
  Uint8,
  Uint16,
  Uint16BE,
  Uint16LE,
  Uint32,
  Uint32BE,
  Uint32LE,
  Uint64,
  Uint64BE,
  Uint64LE,
  Uint128,
  Uint128BE,
  Uint128LE,
  Uint256,
  Uint256BE,
  Uint256LE,
  Uint512,
  Uint512BE,
  Uint512LE,
} from "@ckb-lumos/codec/lib/number";

export {
  createBytesCodec,
  createFixedBytesCodec,
  createObjectCodec,
  createArrayCodec,
  createNullableCodec,
  isFixedCodec,
} from "@ckb-lumos/codec";

export { blockchain } from "@ckb-lumos/base";
